<template>
  <div class="list">
    <div class="list-detail-container">
      <el-table
        :header-cell-style="{
          background: '#032F6D',
          'text-align': 'center',
          'border-style': 'none',
        }"
        :cell-style="{ borderColor: '#afc6e8', color: '#333333' }"
        stripe
        border
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="country" width="80" label="Nation">
        </el-table-column>
        <el-table-column prop="project_name" label="Project">
          <template slot-scope="scope">
            <span
              class="detail"
              @click="toDetail(scope.row.addr_url)"
              v-if="scope.row.addr_url"
              style=""
              :href="scope.row.addr_url"
              target="_blank"
              >{{ scope.row.project_name }}</span
            >
            <span v-if="!scope.row.addr_url">{{ scope.row.project_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sponsor" width="200" label="Sponsor">
        </el-table-column>
        <el-table-column prop="members" width="160" label="Member">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Bread from "./Bread.vue";
export default {
  components: {
    Bread,
  },
  name: "Table",
  created() {
    this.getInfo();
    this.initData();
  },
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    getInfo() {
      let url = `${window._CONFIG["domianURL"]}xmu/index/getData/4c395100b9994e7cb2880cf70327dc69?`;
      // let token = JSON.parse(localStorage.getItem("pro__Access-Token")).value;
      let params = {
        pageNo: 1,
        pageSize: 999,
        is_publish: 1,
        column: "id",
        order: "desc",
        superQueryMatchType: "and",
      };
      this.$axios({
        method: "get",
        url: url,
        headers: {},
        params:params,
        // data: sendobj,
      }).then((res) => {
        let data = res.data.result.records;
        console.log("data", data);
        data.forEach((item) => {
          item.country = item.country.split(",").join(",\n");
          item.members = item.members.split(",").join(",\n\n");
          if (item.is_publish == 1) {
            this.tableData.push({
              country: item.country,
              addr_url: item.addr_url,
              project_name: item.project_name,
              sponsor: item.sponsor,
              members: item.members,
            });
          }
        });
      });
      for (let index = 0; index < 10; index++) {
        const element = this.tableData[index];
        // element.show = true
      }
      console.log(this.tableData);
    },
    initData() {},
    toDetail(url) {
      console.log(`table`, url);
      this.$router.push({
        path: `/content`,
        query: {
          title: this.$route.query.title,
          name: this.$route.query.name,
          ucode: this.$route.query.code,
          id: url,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
header {
  background-color: rgb(0 0 0 / 10%);
}
.list-detail-container {
  margin-top: 20px;
  // padding: 0 100px 15px 100px;
}
.list {
  margin: 0 190px 15px 190px;
  padding: 0 100px 15px 100px;
  border: 1px solid #e6e6e6;
  box-shadow: 2px 6px 8px 0px rgba(32, 32, 32, 0.13);
  position: relative;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
.list-header {
  height: 40px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail {
  cursor: pointer;
  text-decoration: underline;
  color: #073d82;
}
/deep/.el-menu {
  background-color: unset;
}
/deep/.el-table thead {
  color: #fff;
  font-weight: 500;
  background-color: #032f6d;
}

/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f1f7ff;
}
/deep/.el-table .cell {
  white-space: pre-line;
  word-break: unset;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  a {
    color: #073d82;
  }
}
</style>
